import React, { Fragment } from "react";
import { HorizontalToolbar, Divider } from "@theorgchartdev/storybook";
import ChartBreadcrumbs from "./ChartBreadcrumbs/ChartBreadcrumbs";
import ChartNavigationComposite from "./ChartNavigationComposite/ChartNavigationComposite";
import { GetToolbarStyle, RenderToolbarContent } from "./ContextualToolbar";
import { Globals } from "@coreapp/CoreApp/Globals";
import { getFeatureAccess } from "@/Utils/Misc";
import { enumFeaturesList } from "@coreapp/constants";

const ContextualToolbarDefault = ({ isSelection }) => {
  let showBreadCrumbs =
    Globals._uiConfig.fBreadCrumbs && getFeatureAccess(enumFeaturesList.breadcrumbs);

  const leftContent = (
    <Fragment>
      <Fragment>
        <ChartNavigationComposite />
        <div className={"ocn-toolbar-horizontal-divider"}>
          <Divider vertical={true} />
        </div>
      </Fragment>
      {showBreadCrumbs && <ChartBreadcrumbs />}
    </Fragment>
  );

  return (
    <HorizontalToolbar
      style={GetToolbarStyle()}
      leftContent={RenderToolbarContent() ? leftContent : null}
    />
  );
};

export default ContextualToolbarDefault;
